"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var prop_types_1 = require("prop-types");

var index_1 = require("../../index");

require("./index.css");

var MIN_ROWS = 1;
var LEFT_MARGIN_ICON = 16;

var getTextWidth = function (text, font) {
  // eslint-disable-next-line no-undef
  var canvas = document.createElement('canvas');
  var context = canvas.getContext('2d');
  context.font = font;
  return context.measureText(text).width;
};

var InlineText = function (_a) {
  var field = _a.field,
      disabled = _a.disabled,
      className = _a.className,
      error = _a.error,
      label = _a.label,
      placeholder = _a.placeholder,
      suggestedLength = _a.suggestedLength,
      maxLength = _a.maxLength,
      onFocus = _a.onFocus,
      onBlur = _a.onBlur;

  var _b = (0, react_1.useState)(false),
      focus = _b[0],
      setFocus = _b[1];

  var _c = (0, react_1.useState)(0),
      textwidth = _c[0],
      setTextWidth = _c[1];

  var ref = (0, react_1.useRef)();
  var containerClass = "textarea-container " + className;

  if (focus) {
    containerClass += ' focus label-lifted';
  }

  if (error) {
    containerClass += ' error';
  }

  var handleOnBlur = function () {
    setFocus(false);
    if (onBlur) onBlur();
  };

  (0, react_1.useLayoutEffect)(function () {
    if (ref.current) {
      var currentText = field.value === '' ? ref.current.getAttribute('placeholder') : field.value;
      var textWidth = getTextWidth(currentText, // eslint-disable-next-line no-undef
      getComputedStyle(ref.current).font);
      setTextWidth(textWidth + LEFT_MARGIN_ICON);
      ref.current.rows = MIN_ROWS; // eslint-disable-next-line no-undef

      var lineHeight = getComputedStyle(ref.current).lineHeight.match(/(\d+)/)[0];
      var currentRows = Math.floor(ref.current.scrollHeight / lineHeight);
      ref.current.rows = Math.ceil(Math.max(currentRows, MIN_ROWS));
    }
  }, [field]);
  return (0, jsx_runtime_1.jsxs)("div", __assign({
    className: "inlinetext-container",
    "data-testid": "inline-text-" + field.name
  }, {
    children: [(0, jsx_runtime_1.jsxs)("div", __assign({
      className: field.value && maxLength && field.value.length > maxLength ? containerClass + " error" : containerClass,
      "data-testid": "textarea-container"
    }, {
      children: [(0, jsx_runtime_1.jsx)("label", __assign({
        className: "inline-text-control-label",
        htmlFor: field.name,
        "data-testid": "inline-text-control-label-" + field.name
      }, {
        children: label
      }), void 0), (0, jsx_runtime_1.jsx)("textarea", {
        className: "text-area",
        id: field.name,
        name: field.name,
        value: field.value || '',
        rows: 1,
        placeholder: placeholder,
        "data-testid": "text-area-" + field.name,
        onChange: field.onChange || function () {},
        onFocus: function (e) {
          setFocus(true);
          onFocus(e);
        },
        onBlur: handleOnBlur,
        ref: ref,
        disabled: disabled
      }, void 0), (0, jsx_runtime_1.jsx)("span", __assign({
        className: "edit-icon",
        style: {
          left: textwidth
        }
      }, {
        children: (0, jsx_runtime_1.jsx)(index_1.Icon, {
          name: "pencil",
          className: "" + (className || 'fill icon-grey'),
          width: 20
        }, void 0)
      }), void 0)]
    }), void 0), error && error.length > 0 && (0, jsx_runtime_1.jsxs)("div", __assign({
      className: "inline-text-error"
    }, {
      children: [(0, jsx_runtime_1.jsx)(index_1.Icon, {
        name: "alert",
        className: "fill icon-error input-error-icon",
        "data-testid": field.name + "-error-icon",
        width: 16
      }, void 0), (0, jsx_runtime_1.jsx)("span", {
        children: error
      }, void 0)]
    }), void 0), suggestedLength && maxLength && (focus || field.value.length > 0) && (0, jsx_runtime_1.jsxs)("div", __assign({
      className: field.value.length > maxLength ? 'character-count error' : 'character-count'
    }, {
      children: [field.value.length > suggestedLength && (0, jsx_runtime_1.jsx)(index_1.Tooltip, __assign({
        direction: "top",
        tip: "Suggested character count exceeded"
      }, {
        children: (0, jsx_runtime_1.jsx)(index_1.Icon, {
          name: field.value.length > suggestedLength && field.value.length < maxLength ? 'information' : 'alert',
          className: field.value.length > suggestedLength && field.value.length < maxLength ? 'fill icon-yellow info' : 'fill icon-error error',
          width: 16
        }, void 0)
      }), void 0), (field.value ? field.value.length : 0) + " / " + suggestedLength, field.value.length > maxLength && ' Number of characters exceeds the availble space in the report']
    }), void 0)]
  }), void 0);
};

InlineText.propTypes = {
  field: (0, prop_types_1.shape)({
    name: prop_types_1.string,
    value: prop_types_1.string,
    onChange: prop_types_1.func
  }),
  className: prop_types_1.string,
  placeholder: prop_types_1.string,
  label: prop_types_1.string,
  error: prop_types_1.string,
  suggestedLength: prop_types_1.number,
  maxLength: prop_types_1.number,
  onFocus: prop_types_1.func,
  disabled: prop_types_1.bool,
  onBlur: prop_types_1.func
};
InlineText.defaultProps = {
  field: {
    name: '',
    value: '',
    onChange: function () {}
  },
  className: '',
  label: '',
  error: null,
  placeholder: null,
  suggestedLength: null,
  maxLength: null,
  disabled: false,
  onFocus: function (e) {},
  onBlur: function () {}
};
exports.default = InlineText;